import React from 'react';
import ChipInput from 'material-ui-chip-input';
import styled from 'styled-components';
import _ from 'lodash';

const StyledChipInput = styled(ChipInput)`
  & > div:first-child {
    & > div {
      & > div {
        ${'' /* style for chip */} background: ${props =>
  props.theme.color.secondary} !important;
        border-radius: 3px !important;
        & > span {
          ${'' /* chip font color */} color: white !important;
        }
        & > svg {
          ${
            '' /* override cancel button style */
          } fill: rgba(255, 255, 255, 0.76) !important;
        }
      }
    }
  }
`;

const Input = ({ action, filter }) => {
  const localFilter = _.cloneDeep(filter);
  const { source } = localFilter;
  return (
    <div>
      <StyledChipInput
        hintText={`Select ${localFilter.title}`}
        value={localFilter.value}
        dataSource={localFilter.source}
        // TODO - please remeber to remap the api response and use
        // correct dataSourceConfig to support both option label & option value
        // Please see below file for sample setup ( check const mappedData for detail)
        // src/features/scheduling-reports/actions.js
        dataSourceConfig={{ text: 'label', value: 'value' }}
        onBeforeRequestAdd={chip => {
          const val = chip && typeof chip === 'object' ? chip.value : chip;
          const foundVal = source.find(x => val.toUpperCase() ===  x.value.toUpperCase());
          return !!foundVal;
        }}
        onRequestAdd={chip => {
          localFilter.value.push(chip);
          action(localFilter);
        }}
        onRequestDelete={(chip, index) => {
          localFilter.value.splice(index, 1);
          action(localFilter);
        }}
        fullWidth
        fullWidthInput
        menuStyle={{ height: '320px' }}
        popoverProps={{ canAutoPosition: false }}
        openOnFocus
      />
    </div>
  );
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/filter/filters/chip-input/ChipInput.js